export enum ModalEntityActionType {
  Add = 'Add',
  Save = 'Save',
  Delete = 'Delete',
  Custom = 'Custom',
}
